import { localServerURL } from "./config";

//testnet
//export const CONTRACT_PUBLIC_KEY = "PUB_K1_8Fd9NZLpXr5vZZZvkHurRpbNKAYnqTdhATUiLxtKGT5A7GXg8x";

//mainnet
export const CONTRACT_PUBLIC_KEY = "PUB_K1_7QK6aXXScbRRrfb9LaPfZKy8BU6FUmsn2HaXG5tVJMw4E6bMiu";
export const CONTRACT_PUBLIC_KEY_OLD_FORMAT = "EOS7QK6aXXScbRRrfb9LaPfZKy8BU6FUmsn2HaXG5tVJMw4Cv6ZV1";


export const isAnAdmin = (user) => {
    const admins = ["mikedcrypto5", "blu33t3st1ng"]
	if(admins.indexOf(user) > -1) return true
}

export const WHITEPAPER_URL = "https://drive.google.com/file/d/1v0foenqMEmgqlxtdwx71qVwo57x_wtTU/view"

//export const resizerPrefix = "https://api.waxdao.io/image/w_300,h_300/https://ipfs.io/ipfs/"
//export const resizerPrefix = localServerURL + "/image/w_300,h_300/https://ipfs.io/ipfs/"
export const resizerPrefix = "https://ipfs.waxdaobp.io/ipfs/"
export const ipfsPrefix = "https://ipfs.io/ipfs/"

export const resizerSuffix = ""

export const DROP_FILTERS = [
	{value: "Hide sold out", display_text: "Hide Sold Out"},
	{value: "Live drops only", display_text: "Live Only"}, 
];

export const FARM_STATUSES = [
	{value: 0, display_text: "Temporarily Closed"},
	{value: 1, display_text: "Open"}, 
	{value: 2, display_text: "Permanently Closed"}, 
];

export const OP_TYPES = [
	{value: 0, display_text: "Any X Of"},
	{value: 1, display_text: "All Of"}
];

